module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 0iPh
// module chunks = 15 19 21 22 23 24 27 29 32 33 35 36 39 40 41 48 51 52 53 54 56 57 59 60 62 63 66 67